module.exports = __webpack_public_path__ + "static/media/face1.74033661.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/FeedbackForm/images/face1.svg
// module id = 1221
// module chunks = 2